
import jwt_decode from "jwt-decode";

export type TokenDecoded = {
	id: string | null,	
	condominioContextoId: string | null,
	[key: string]: any,
	permissoesGrupoAcesso: string | null,
	possuiCom21: boolean | null,
	possuiGroupSign: boolean | null,
}

export const TOKEN_VAZIO = { 
	id: null, 
	nome: null, 
	condominioContextoId: null,
	permissoesGrupoAcesso: null,
	possuiCom21: null,
	possuiGroupSign: false

 };

export function getTokenDecoded() {
	let tokenDecoded: TokenDecoded = TOKEN_VAZIO;
	const token = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');


	let isTokenValido = false;
	if (token) {
		try {
			tokenDecoded = jwt_decode(token);

			if (tokenDecoded) {
				isTokenValido = new Date().getTime() / 1000 <= tokenDecoded.exp;
			}

		} catch (e) {
			console.log("TOKEN INVÁLIDO! " + e);
		}

	}
	if (!isTokenValido) {
		tokenDecoded = TOKEN_VAZIO;
	}
	

	return tokenDecoded;
}